import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "DisplayName",
    isNumber: true,
    isSum: true,
  },
];

export const VillageToCaseStatus = {
  label: "鄉鎮 VS 案件狀態",
  key: "VillageToCaseStatus",
  path: "BoneMuscleCare/VillageToCaseStatus",
  api: "TCS_V_UserInfoCaseV",
  render: (options) => (
    <Diagram.BoneMuscleCare.VillageToCaseStatus {...options} />
  ),
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "RegionName",
      field: "RegionName",
      header: "",
    },
  ],
  dateRangeColumns: [
    // "Birthday",
    // "CaseCreateDate",
    { label: "Q3967", key: "Q3967" },
  ],
  levelColumns,
  columns: [],
};
